export default "__VITE_ASSET__jP5nfQCY__"